<template>
  <Observer class="side announced" @show="reportShow">
    <div class="h-tt">
      <h2>新服预告</h2>
    </div>
    <div class="box">
      <div class="h-tab">
        <a
          href="javascript:;"
          :class="{ cur: tab == 1 }"
          @click="
            tab = 1
            $util.clickStat(`GWSY/ZXKF`, `官网首页/最新开服`)
          "
        >
          最新开服
        </a>
        <a
          href="javascript:;"
          :class="{ cur: tab == 0 }"
          @click="
            tab = 0
            $util.clickStat(`GWSY/XFYG`, `官网首页/新服预告`)
          "
        >
          新服预告
        </a>
      </div>
      <div
        class="scroll-warp"
        :style="`transform: translateX(${!tab * -324}px)`"
      >
        <div v-for="i in [1, 0]" :ref="`scroll${i}`" :key="i" class="scorll">
          <ul :data-key="i">
            <li v-for="item in getSevers(i).data" :key="item.id">
              <a
                href="javascript:;"
                @click="
                  goGame(item, i)
                  reportClick(item)
                "
              >
                <span class="s1">{{ item.game_title }}</span>
                <span class="s2">{{ item.title }}</span>
                <span class="s3">{{ convertTime(item) }}</span>
              </a>
            </li>
          </ul>
          <InfiniteLoading
            spinner="bubbles"
            :identifier="i"
            @infinite="infiniteHandler($event, i)"
          >
            <template slot="no-more"><i /></template>
            <div slot="no-results" class="record-list-null">
              {{ i ? '暂无开服预告哦' : '暂无新服预告哦' }}
            </div>
          </InfiniteLoading>
        </div>
      </div>
    </div>
  </Observer>
</template>

<script>
import dayjs from 'dayjs'
export default {
  data() {
    return {
      newServer: {
        name: 'newServer',
        page: 1,
        data: [],
        ref: 'scroll0'
      },
      newOpen: {
        name: 'newOpenServer',
        page: 1,
        data: [],
        ref: 'scroll1'
      },
      isScrollStat: true,
      tab: 1
    }
  },
  mounted() {
    this.$refs.scroll0[0].addEventListener('scroll', this.handleScroll)
    this.$refs.scroll1[0].addEventListener('scroll', this.handleScroll)
  },
  methods: {
    reportShow() {
      this.$xlaPush('home_page_new_server_show', {
        tab: this.tab ? 'latest_server' : 'advance_server'
      })
    },
    reportClick({ game_id, server_id }) {
      this.$xlaPush('home_page_new_server_click', {
        tab: this.tab ? 'latest_server' : 'advance_server',
        game_id,
        channel: server_id
      })
    },
    goGame(item, i) {
      if (i) {
        this.$util.playGame(item)
      } else {
        this.$util.gamePage(item)
      }
    },
    getSevers(i) {
      return i ? this.newOpen : this.newServer
    },
    convertTime({ opened_at }) {
      return dayjs(opened_at).format('MM-DD HH:mm')
    },
    infiniteHandler($state, tab) {
      const server = this.getSevers(tab)
      if (server.page > 1) {
        $state.complete()
        return
      }
      this.$request(server.name, { body: { page: server.page } })
        .then((data) => {
          const resDate = [...server.data, ...data]
          server.data = resDate
          if (server.page === 1 && !server.data.length) {
            $state.complete()
          } else {
            $state.loaded()
            if (data.length < 20) $state.complete()
          }
          server.page += 1
        })
        .catch(() => {
          $state.complete()
        })
    },
    handleScroll() {
      if (this.isScrollStat) {
        this.isScrollStat = false
        this.$util.clickStat(`GWSY/HT`, `官网首页/滑条`)
      }
    }
  }
}
</script>
